import {
  NAVIGATION_OPEN_ITEM,
  NAVIGATION_CLOSE_ITEM,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAILURE,
  AUTH_RESET_PASSWORD_SUCCESS,
  AUTH_RESET_PASSWORD_FAILURE,
  SNACKBAR_SHOW,
  SNACKBAR_HIDE,
  MENU_OPEN,
  MENU_CLOSE,
  ASYNC_INDICATOR_SHOW,
  ASYNC_INDICATOR_HIDE,
  DISPLAY_RESET_PASSWORD,
  RESET_TMP_PASSWORD,
  CHANGE_USER_MERCHANT_SUCCESS,
  GET_USER_MERCHANTS_SUCCESS,
} from "../actions";
import { buildPrivileges, checkPrivileges } from "../auth/privileges";
import auth from "../auth/constants";

const reducedNav = (user) => [
  { divider: true },
  {
    icon: "AdminIcon",
    label: "Administration",
    title: "Administration marchands",
    to: `/configuration/marchands/${user.merchant}`,
  },
];

const reducedNavMerchantGroup = (user) => [
  { divider: true },
  {
    opened: false,
    icon: "AdminIcon",
    label: "Administration",
    title: "Administration marchands",
    to: "/configuration/marchands",
    children: [
      {
        icon: "MerchantIcon",
        label: "des marchands",
        title: "Administration marchands",
        to: "/configuration/marchands",
      },
    ],
  },
];

const extendedNav = (user) => [
  { divider: true },
  {
    opened: false,
    icon: "AdminIcon",
    label: "Administration",
    title: "Administration marchands",
    to: "/configuration/marchands",
    children: [
      {
        icon: "MerchantIcon",
        label: "des marchands",
        title: "Administration marchands",
        to: "/configuration/marchands",
      },
      {
        icon: "ShareIcon",
        label: "des partenariats",
        title: "Administration partenariats",
        to: "/configuration/partenariats",
      },
    ],
  },
  {
    icon: "AccountingIcon",
    label: "Requêtes",
    title: "Requetes enregistrées",
    to: "/requetes",
  },
];

export const buildNavigation = (user) => {
  const commons = [
    {
      icon: "StatsIcon",
      label: "Statistiques",
      title: "Statistiques commerciales",
      to: "/statistiques",
    },
    {
      opened: false,
      icon: "VentesIcon",
      label: "Suivi des ventes",
      title: "Suivi des ventes",
      to: "/ventes/par-commandes",
    },
  ];
  const specific = checkPrivileges(user.privileges, auth.FULL_NAV)
    ? extendedNav(user)
    : checkPrivileges(user.privileges, auth.REDUCED_NAV_MERCHANT_GROUP)
    ? reducedNavMerchantGroup(user)
    : checkPrivileges(user.privileges, auth.REDUCED_NAV)
    ? reducedNav(user)
    : [];
  return [...commons, ...specific];
};

export const APP_SHAPE = {
  waiting: false,
  menuOpened: false,
  snackbar: {
    open: false,
    message: "",
  },
  auth: {
    token: null,
    user: null,
    logged: false,
    tmpPassword: false,
  },
  navigation: [],
};

const updateNavigation = (items, updater) =>
  items.map((item) => ({
    ...updater(item),
    children: item.children
      ? updateNavigation(item.children, updater)
      : undefined,
  }));

const reducer = (state = APP_SHAPE, action) => {
  switch (action.type) {
    case NAVIGATION_OPEN_ITEM:
      return {
        ...state,
        navigation: updateNavigation(state.navigation, (item) =>
          item.to !== action.to ? item : { ...item, opened: true }
        ),
      };

    case NAVIGATION_CLOSE_ITEM:
      return {
        ...state,
        navigation: updateNavigation(state.navigation, (item) =>
          item.to !== action.to ? item : { ...item, opened: false }
        ),
      };

    case MENU_OPEN:
      return { ...state, menuOpened: true };

    case MENU_CLOSE:
      return { ...state, menuOpened: false };

    case ASYNC_INDICATOR_SHOW:
      return { ...state, waiting: true };

    case ASYNC_INDICATOR_HIDE:
      return { ...state, waiting: false };

    case SNACKBAR_SHOW:
      return {
        ...state,
        snackbar: { open: true, message: action.message },
      };
    case SNACKBAR_HIDE:
      return {
        ...state,
        snackbar: { open: false, message: "" },
      };

    case AUTH_LOGIN_SUCCESS:
    case AUTH_RESET_PASSWORD_SUCCESS:
    case CHANGE_USER_MERCHANT_SUCCESS:
      const user = {
        ...action.user,
        privileges: buildPrivileges(action.user.roles),
      };
      return {
        ...state,
        waiting: false,
        auth: {
          logged: true,
          tmpPassword: false,
          token: action.token,
          user,
        },
        navigation: buildNavigation(user),
      };

    case GET_USER_MERCHANTS_SUCCESS:
      return {
        ...state,
        waiting: false,
        auth: {
          ...state.auth,
          user: { ...state.auth.user, merchants: action.merchants },
        },
      };

    case AUTH_LOGIN_FAILURE:
      return {
        ...state,
        waiting: false,
        auth: APP_SHAPE.auth,
      };

    case AUTH_RESET_PASSWORD_FAILURE:
      return {
        ...state,
        waiting: false,
        auth: {
          tmpPassword: true,
          logged: false,
          token: null,
          user: null,
        },
      };

    case DISPLAY_RESET_PASSWORD:
      return {
        ...state,
        auth: { ...state.auth, tmpPassword: true },
      };

    case RESET_TMP_PASSWORD:
      return {
        ...state,
        auth: { ...state.auth, tmpPassword: false },
      };

    default:
      return state;
  }
};

const loadState = () => {
  const state = sessionStorage["appState"];
  return state ? JSON.parse(state) : APP_SHAPE;
};

export default (state = loadState(), action) => {
  const newState = reducer(state, action);
  sessionStorage["appState"] = JSON.stringify(newState);
  return newState;
};



// WEBPACK FOOTER //
// ./src/app/reducers.js